import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation, faCircleInfo, faCircleCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';

import { supportUrl } from 'Config/lang';
import DangerousHTML from 'Components/Utility/DangerousHTML';

const titles = defineMessages({
  error: {
    id: 'message-box.error',
    defaultMessage: 'Error',
  },
  success: {
    id: 'message-box.success',
    defaultMessage: 'Success',
  },
  warning: {
    id: 'message-box.warning',
    defaultMessage: 'Warning',
  },
  info: {
    id: 'message-box.info',
    defaultMessage: 'Info',
  },
});

const MessageBox = ({
  type,
  message,
  title,
  dismissible,
  closeFunction,
  supportLink,
  paymentSupport,
  removeVoucher,
  intl: { formatMessage },
}) => {
  let errorTitle = title;
  if (isEmpty(title)) {
    errorTitle = formatMessage(titles[type] || titles.info);
  }

  return (
    <div className={`message-box message-box-${type}`}>
      <div className="message-box-icon-container">
        <div className="message-box-icon">
          {type === 'error' && <FontAwesomeIcon icon={faTriangleExclamation} />}
          {type === 'info' && <FontAwesomeIcon icon={faCircleInfo} />}
          {type === 'warning' && <FontAwesomeIcon icon={faTriangleExclamation} />}
          {type === 'success' && <FontAwesomeIcon icon={faCircleCheck} />}
        </div>
      </div>
      <div className="message-box-message">
        <span className="m-0">
          <span className="message-box-title">{errorTitle}</span> -&nbsp;
          <DangerousHTML tag="span" html={message} />
          {paymentSupport &&
            <React.Fragment>
              <span>&nbsp;-&nbsp;</span>
              <a href={`${supportUrl()}/categories/200128881?errorCode=${paymentSupport}`} target="_blank" rel="noopener noreferrer">
                <FormattedMessage id="payment-error.supportlink" defaultMessage="Payment Support" />
              </a>
            </React.Fragment>
          }
          {supportLink &&
            <p className="mt-1"><a href={`${supportUrl()}/articles/${supportLink}`} target="_blank" rel="noopener noreferrer">
              <FormattedMessage id="epic-connect.troubleshoot" defaultMessage="Click here to troubleshoot" />
            </a></p>
          }
          {removeVoucher &&
            <React.Fragment>
              <span>&nbsp;-&nbsp;</span>
              <button className="btn btn-link m-0 p-0" onClick={() => removeVoucher()}>
                <FormattedMessage id="message-box.remove-voucher" defaultMessage="Remove Discount Code" />
              </button>
            </React.Fragment>
          }
        </span>
      </div>
      {dismissible &&
        <div className="message-box-button-container">
          <Button
            color="link"
            className="close-button"
            onClick={closeFunction}
          >
            <FontAwesomeIcon icon={faXmark} title="Dismiss message" />
          </Button>
        </div>
      }
    </div>
  );
};

MessageBox.propTypes = {
  type: PropTypes.oneOf([
    'error',
    'info',
    'success',
  ]),
  message: PropTypes.string,
  supportLink: PropTypes.number,
  title: PropTypes.string,
  dismissible: PropTypes.bool,
  paymentSupport: PropTypes.string,
  closeFunction: PropTypes.func,
  removeVoucher: PropTypes.func,
};

MessageBox.defaultProps = {
  type: 'info',
  message: '',
  supportLink: null,
  title: '',
  dismissible: false,
  paymentSupport: null,
  closeFunction: () => {},
  removeVoucher: null,
};

export default injectIntl(MessageBox);
